import { NgModule } from '@angular/core';

import { LoginViewComponent } from './login-view.component';

@NgModule({
  declarations: [LoginViewComponent],
  imports: [],
  providers: [],
})
export class LoginViewModule {}
